import React from 'react'
import Font from 'Survey/Shared/Font/Font'
import style from './style.module.scss'

export default () =>
  <div className={style.page}><Font size='xl'>Internet connection was lost<br/>Please connect to continue</Font></div>
